<template>
  <div class="ma-4">
    <SkeletonLoaderTitleUpdate v-show="showSkeleton" />

    <div class="text-h4" v-show="!showSkeleton">Atualizar {{ `${description} - ${tipo}` }}</div>

    <AbaTroncoPjsip v-if="canRender && tipo === 'PJSIP'" edicao="true" :_id="_id" />
    <AbaTroncoPjsipTrunk v-if="canRender && tipo === 'PJSIPTRUNK'" edicao="true" :_id="_id" />
    <AbaTroncoIax v-if="canRender && tipo === 'IAX'" edicao="true" :_id="_id" />
    <AbaTroncoIaxTrunk v-if="canRender && tipo === 'IAXTRUNK'" edicao="true" :_id="_id" />
    <AbaTroncoKhomp v-if="canRender && tipo === 'KHOMP'" edicao="true" :_id="_id" />
    <AbaTroncoSipProxy v-if="canRender && tipo === 'SIP-PROXY'" edicao="true" :_id="_id" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import SkeletonLoaderTitleUpdate from '@/componentes/SkeletonLoaderTitleUpdate'

import troncosStore from './../_store'
import AbaTroncoPjsip from '../_components/AbaTroncoPjsip'
import AbaTroncoPjsipTrunk from '../_components/AbaTroncoPjsipTrunk'
import AbaTroncoIax from '../_components/AbaTroncoIax'
import AbaTroncoIaxTrunk from '../_components/AbaTroncoIaxTrunk'
import AbaTroncoKhomp from '../_components/AbaTroncoKhomp'
import AbaTroncoSipProxy from '../_components/AbaTroncoSipProxy'


export default {
  name: 'AtualizarTroncos',
  props: {
    _id: String,
  },
  components: {
    AbaTroncoPjsip,
    AbaTroncoPjsipTrunk,
    AbaTroncoIax,
    AbaTroncoIaxTrunk,
    AbaTroncoKhomp,
    AbaTroncoSipProxy,
    SkeletonLoaderTitleUpdate,
  },
  data: () => ({
    tipo: '',
    description: '',
    showSkeleton: false,
    canRender: false,
  }),
  computed: {
    ...mapGetters('atualizarTroncosModulePABXStore', ['getTroncoSelecionado']),
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'atualizarTroncosModulePABXStore', troncosStore)
    await this.selecionarTronco(this._id)
    this.tipo = this.getTroncoSelecionado.tipo
    this.description = this.getTroncoSelecionado.description

    this.showSkeleton = false
    this.canRender = true
  },
  methods: {
    ...mapActions('atualizarTroncosModulePABXStore', ['selecionarTronco']),
  },
}
</script>
